var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('el-input',{staticClass:"search-input",attrs:{"maxlength":20,"placeholder":"搜索"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('el-button',{attrs:{"slot":"append","type":"primary","icon":"el-icon-search"},on:{"click":_vm.clickHandler},slot:"append"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }